// https://stackoverflow.com/a/53308988/6138965
if (!Array.prototype.includes) {
  // or use Object.defineProperty
  // eslint-disable-next-line
  Array.prototype.includes = function(search) {
    return !!~this.indexOf(search);
  };
}
